import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClinicalOnboardingConfig } from '../../../models/clinical-onboarding.model';

/**
 * DBEK-392: pagina di gestione dell'onboarding clinico / lettere di incarico -
 * orchestratore che compone Config (sempre visibile, e' l'unico modo per
 * accendere la feature la prima volta), Document Templates e Dashboard (questi
 * due solo quando gia' abilitata). Montata come nuova tab in survey-details-page.
 */
@Component({
  selector: 'app-clinical-onboarding-management',
  templateUrl: './clinical-onboarding-management.component.html',
  styleUrls: ['./clinical-onboarding-management.component.scss'],
  standalone: false,
})
export class ClinicalOnboardingManagementComponent {
  @Input() survey: any;
  @Input() surveyId: string | number;
  @Output() surveyChanged = new EventEmitter<any>();

  get config(): ClinicalOnboardingConfig | null {
    return this.survey?.customs?.clinical_onboarding ?? null;
  }

  get enabled(): boolean {
    return !!this.config?.enabled;
  }

  onConfigSaved(config: ClinicalOnboardingConfig): void {
    if (!this.survey.customs) {
      this.survey.customs = {};
    }
    this.survey.customs.clinical_onboarding = config;
    this.surveyChanged.emit(this.survey);
  }
}
